import {ADD_IMAGE, START, TICK, SUCCESS, FAIL} from "../constants/action-types";
import {API_IMAGES} from "../constants/api";
import {addPictureToCanvas} from "./add-picture-to-canvas";
import {closeAllModals} from "./modal";
import {PICTURE_POLL_TIME} from "../constants";

export const addImage = (id, fields = {}) => (dispatch, getState) => {
  const {mobileApp} = getState();
  const authHeader = mobileApp ? window.authHeaders : {};
  dispatch({
    type: ADD_IMAGE + START
  });
  dispatch(closeAllModals());
  const interval = setInterval(() => {
    fetch(`${API_IMAGES}/${id}`, {
      headers: {
        "Accept": `application/json`,
        "Content-Type": `application/json`,
        ...authHeader
      },
      credentials: `same-origin`
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error(`Error`);
        }
        return res.json();
      })
      .then((response) => {
        if (!response) {
          dispatch({type: ADD_IMAGE + TICK});
        } else {
          clearInterval(interval);
          const {
            picture_content_type: type,
            canvas_url: original,
            original_width: originalWidth,
            original_height: originalHeight
          } = response;
          dispatch(
            addPictureToCanvas(
              {
                id,
                type,
                original,
                originalWidth,
                originalHeight
              },
              {},
              fields
            )
          );
          dispatch({type: ADD_IMAGE + SUCCESS, response});
        }
      })
      .catch((error) => {
        clearInterval(interval);
        dispatch({type: ADD_IMAGE + FAIL, error});
      });
  }, PICTURE_POLL_TIME);
};
